///////////////////////////////////////////////
//      Progress indicator styling           //
///////////////////////////////////////////////

@import './pk-progress-indicator.variables';

:host {
  @apply block;
}

.linear {
  @apply flex h-[var(--progress-indicator--stroke-width)];

  .wrapper {
    @apply flex w-full rounded-full bg-[color:var(--progress-indicator--track-area-color)];
  }

  .progress-bar {
    @apply mr-[var(--progress-indicator--spacing)] rounded-full;

    &:last-child {
      @apply mr-0;
    }

    &.animation-on {
      @apply animate-[var(--progress-indicator--linear-animation)];
    }

    &.linecap-square {
      @apply rounded-[initial];
    }

    &.no-space {
      @apply rounded-none [--progress-indicator--spacing:0];

      &:last-child {
        @apply rounded-[0_999px_999px_0];
      }

      &:first-child {
        @apply rounded-[999px_0_0_999px];
      }
    }
  }

  @keyframes progress-line {
    from {
      width: 0;
    }

    to {
      width: var(--progress-indicator--final-percentage);
    }
  }
}

.circular {
  @apply relative h-[var(--progress-indicator--circular-size)] w-[var(--progress-indicator--circular-size)] rounded-[50%];

  .circle {
    @apply block;
  }

  .track-area,
  .progress {
    r: calc(50% - var(--progress-indicator--stroke-width) * 0.5);
  }

  .track-area {
    @apply fill-[var(--progress-indicator--circular-inner-bg)];

    stroke: var(--progress-indicator--track-area-color);
    stroke-width: var(--progress-indicator--stroke-width);
  }

  .progress {
    @apply origin-center -rotate-90 fill-[none];

    stroke: var(--progress-indicator--progress-color);
    stroke-linecap: round;
    stroke-width: var(--progress-indicator--stroke-width);

    &.linecap-square {
      stroke-linecap: square;
    }

    &.animation-on {
      @apply animate-[var(--progress-indicator--circular-animation)];
    }
  }

  .circular__text {
    @apply absolute left-0 top-0 flex h-full w-full items-center justify-center rounded-[50%];
  }

  @keyframes progress-circle {
    0% {
      stroke-dasharray: 0 100;
    }
  }
}
